<template>
  <div class="home-page split-view fill-height">
    <v-row class="home-row split-view__row fill-height" no-gutters>
      <left-side-image />

      <v-col cols="12" class="home-panel-col split-view__panel">
        <div class="split-view__scroll">
        <div class="home-panel">
          <header class="home-hero home-enter home-enter--1">
            <h1 class="home-hero__title today-regular">
              FINANCIA TU PÓLIZA DE AUTOMÓVIL
            </h1>
            <p class="home-hero__lead today-light">
              Con VARDI Agencia de Seguros, obtén la financiación que necesitas
              para tu póliza de automóvil de manera rápida y sencilla. ¡Protege
              tu vehículo hoy mismo!
            </p>
          </header>

          <div class="home-actions">
            <v-card
              class="home-action home-enter home-enter--2"
              elevation="0"
              :to="{ name: 'SimulateFinancing' }"
              aria-label="Simular financiación"
            >
              <div class="home-action__icon">
                <v-img
                  class="home-action__image"
                  contain
                  width="72"
                  height="72"
                  alt=""
                  src="@/assets/img/simular.png"
                ></v-img>
              </div>
              <v-card-title class="home-action__title today-medium">
                SIMULAR FINANCIACIÓN
              </v-card-title>
            </v-card>

            <v-card
              class="home-action home-enter home-enter--3"
              elevation="0"
              role="button"
              tabindex="0"
              aria-haspopup="dialog"
              aria-label="Financiar póliza"
              @click="openFinanceDialog"
              @keydown.enter="openFinanceDialog"
              @keydown.space.prevent="openFinanceDialog"
            >
              <div class="home-action__icon">
                <v-img
                  class="home-action__image"
                  contain
                  width="72"
                  height="72"
                  alt=""
                  src="@/assets/img/financiar.png"
                ></v-img>
              </div>
              <v-card-title class="home-action__title today-medium">
                FINANCIAR PÓLIZA
              </v-card-title>
            </v-card>

            <v-card
              class="home-action home-enter home-enter--4"
              elevation="0"
              href="https://tefio-vardi.bio.credit/sucursal_pago"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Pagar cuota, abre en una pestaña nueva"
            >
              <div class="home-action__icon">
                <v-img
                  class="home-action__image"
                  contain
                  width="72"
                  height="72"
                  alt=""
                  src="@/assets/img/pagar.png"
                ></v-img>
              </div>
              <v-card-title class="home-action__title today-medium">
                PAGAR CUOTA
              </v-card-title>
            </v-card>
          </div>
        </div>
        </div>
      </v-col>
    </v-row>

    <v-dialog
      v-model="dialog"
      max-width="400"
      overlay-color="primary"
      content-class="home-finance-dialog"
    >
      <v-card class="home-finance-card">
        <v-card-title
          class="justify-center text-uppercase primary--text font-weight-bold today-medium home-finance-card__title"
        >
          Financiar póliza
        </v-card-title>
        <div class="px-10 px-md-12 pb-7">
          <p class="home-finance-card__hint today-light">
            Ingresa tu documento para continuar con la solicitud.
          </p>

          <v-form ref="form" lazy-validation @submit.prevent="singUp">
            <v-select
              v-model="document_type"
              :items="document_types"
              item-text="value"
              item-value="key"
              :rules="[(v) => !!v || 'Selecciona el tipo de documento']"
              label="Tipo de documento"
              name="document_type"
              autocomplete="off"
              required
              outlined
              dense
              color="primary"
              hide-details="auto"
              class="select-field"
            ></v-select>

            <v-text-field
              v-model="document_id"
              :rules="[(v) => !!v || 'Ingresa el número de documento']"
              type="text"
              inputmode="numeric"
              autocomplete="off"
              name="document_id"
              label="Número de documento"
              placeholder="Ej. 1234567890…"
              required
              outlined
              dense
              color="primary"
              hide-details="auto"
              class="input-field mt-4"
            ></v-text-field>

            <v-checkbox
              v-model="terms"
              class="home-finance-card__terms mt-4"
              color="primary"
              hide-details
            >
              <template v-slot:label>
                <span class="home-finance-card__terms-copy">
                  Acepto los
                  <a
                    href="https://vardiseguros.com.co/static/uploads/613b959d-eb39-4cad-b1e4-b9a9344194af.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="home-finance-card__terms-link today-medium"
                    @click.stop
                  >
                    términos, políticas de privacidad y tratamiento de datos
                  </a>
                </span>
              </template>
            </v-checkbox>

            <v-btn
              block
              type="submit"
              :loading="loading"
              :disabled="loading || !terms"
              color="primary"
              elevation="0"
              class="home-finance-btn home-finance-btn--primary today-medium mt-6"
            >
              Continuar
            </v-btn>
          </v-form>
        </div>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      bottom
      right
      role="status"
    >
      <div v-html="snackbarMessage"></div>
    </v-snackbar>
  </div>
</template>

<script>
import OnboardingModal from "@/components/Layouts/OnboardingModal";
import LeftSideImage from "@/components/Layouts/LeftSideImage";
import { api } from "@/helpers/axios";
import { constants } from "@/helpers/constants";
import { locals } from "@/helpers/locals";

export default {
  name: "home-app",
  components: { OnboardingModal, LeftSideImage },
  data() {
    return {
      terms: false,
      document_type: "",
      document_id: "",
      coupon: "",
      dialog: false,
      promoCode: false,
      loading: false,
      settings: null,
      document_types: [],
      snackbar: false,
      timeout: 4000,
      snackbarMessage: "",
      user: null,
      windowHeight: window.innerWidth,
    };
  },
  methods: {
    openFinanceDialog() {
      this.dialog = true;
    },
    singUp() {
      let validate = this.$refs.form.validate();
      if (validate) {
        this.loading = true;

        api
          .post(constants.endPoints.isRegistered, {
            document_type: this.document_type,
            document_id: this.document_id,
            coupon: this.coupon,
          })
          .then(
            function (response) {
              this.loading = false;
              let exist_user = response.data.data.exist_user;
              let exist_sics = response.data.data.exist_sics;

              let user = {
                document_type: this.document_type,
                document_id: this.document_id,
                coupon: this.coupon,
              };

              locals.setLocal("user", JSON.stringify(user));

              if (exist_user) {
                user.login = true;
                locals.setLocal("user", JSON.stringify(user));

                this.$router.push("/preparate-para-selfie");
              } else {
                if (exist_sics.status) {
                  this.$router.push("/registro-de-documento");
                } else {
                  this.snackbarMessage = exist_sics.message;
                  this.snackbar = true;
                }
              }
            }.bind(this)
          )
          .catch(
            function (error) {
              const data =
                (error.response && error.response.data) || {};
              const errors = data.errors || {};
              let message = data.message || "";
              for (var [key, value] of Object.entries(errors)) {
                message = message + value + "<br>";
              }
              this.snackbarMessage =
                message || "No se pudo validar el documento. Inténtalo de nuevo.";
              this.snackbar = true;
              this.loading = false;
            }.bind(this)
          );
      }
    },
    onResize() {
      this.windowHeight = window.innerWidth;
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },

  created() {
    api.get(constants.endPoints.settings).then((response) => {
      locals.setLocal("settings", JSON.stringify(response.data.data));
      this.settings = locals.getLocal("settings");
      this.settings.config.forEach((value) => {
        if (value.key == "document_types") {
          this.document_types = value.value;
        }
      });
    });
    this.user = locals.getLocal("user");
    if (this.user != null) {
      if (this.user.login && this.user.access_token) {
        this.$router.push("/polizas");
      }
    }
  },
};
</script>

<style lang="scss">
.home-page {
  height: 100%;

  .home-row.fill-height {
    height: 100%;
    margin: 0 !important;
  }

  .home-row.fill-height > .home-panel-col {
    box-sizing: border-box;
    text-align: center;
  }

  .home-panel {
    align-items: stretch;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-left: auto;
    margin-right: auto;
    max-width: 880px;
    min-width: 0;
    padding: 104px 40px 40px;
    width: min(880px, 100%);
  }

  .home-hero {
    margin: 0 0 28px;
    max-width: 100%;
    text-align: center;
    width: 100%;
  }

  .home-hero__title {
    color: #00205b;
    font-size: 2rem;
    letter-spacing: 0.01em;
    line-height: 1.15;
    margin: 0;
    text-wrap: balance;
  }

  .home-hero__lead {
    color: rgba(0, 0, 0, 0.64);
    font-size: 1.0625rem;
    line-height: 1.45;
    margin: 16px 0 0;
    text-wrap: pretty;
  }

  .home-actions {
    display: grid;
    gap: 16px;
    grid-template-columns: 1fr;
    margin: 0 auto;
    max-width: 880px;
    width: 100%;
  }

  .home-action {
    background: #f8f9fc !important;
    border: 1px solid #e6e8ee !important;
    border-radius: 16px !important;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    min-width: 0;
    overflow: hidden;
    padding: 20px 16px 16px;
    text-decoration: none !important;
    touch-action: manipulation;
    transition-duration: 150ms;
    transition-property: transform, background-color, border-color, box-shadow;
    transition-timing-function: ease-out;
  }

  .home-action:hover {
    background: #eef1f7 !important;
    border-color: #cfd5e4 !important;
    box-shadow: 0 1px 2px rgba(0, 32, 91, 0.08),
      0 8px 20px rgba(0, 32, 91, 0.08);
  }

  .home-action:active {
    transform: scale(0.96);
  }

  .home-action:focus-visible {
    outline: 2px solid #00205b;
    outline-offset: 3px;
  }

  .home-action__icon {
    align-items: center;
    background: #eef1f7;
    border: 0;
    border-radius: 16px;
    display: flex;
    height: 88px;
    justify-content: center;
    margin: 0 auto;
    overflow: hidden;
    padding: 8px;
    width: 88px;
  }

  .home-action__title {
    color: #00205b !important;
    font-size: 1.0625rem !important;
    justify-content: center;
    letter-spacing: 0.01em;
    line-height: 1.2;
    padding: 16px 8px 4px !important;
    text-align: center;
    text-wrap: balance;
    word-break: inherit;
    white-space: normal;
  }

  .home-enter {
    animation: homeFadeIn 400ms ease-out both;
  }

  .home-enter--1 {
    animation-delay: 0ms;
  }

  .home-enter--2 {
    animation-delay: 100ms;
  }

  .home-enter--3 {
    animation-delay: 200ms;
  }

  .home-enter--4 {
    animation-delay: 300ms;
  }
}

@media (min-width: 960px) {
  .home-page .home-actions {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (min-width: 1264px) {
  .home-page .home-panel {
    padding: 104px 48px 40px;
  }
}

@media (max-width: 600px) {
  .home-page .home-panel {
    padding: 40px 16px 32px;
  }

  .home-page .home-hero__title {
    font-size: 1.7rem;
  }

  .home-page .home-hero__lead {
    font-size: 1rem;
  }
}

@keyframes homeFadeIn {
  from {
    filter: blur(4px);
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    filter: blur(0);
    opacity: 1;
    transform: translateY(0);
  }
}

.home-finance-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  overscroll-behavior: contain;
}

.home-finance-card {
  border-radius: 20px !important;
  overflow: hidden;
}

.home-finance-card__title {
  padding-top: 32px !important;
  text-wrap: balance;
}

.home-finance-card__hint {
  color: rgba(0, 0, 0, 0.64);
  font-size: 0.875rem;
  line-height: 1.45;
  margin: 0 0 20px;
  text-align: center;
  text-wrap: pretty;
}

.home-finance-card__terms {
  margin-top: 8px;
}

.home-finance-card__terms-copy {
  color: rgba(0, 0, 0, 0.64);
  font-size: 0.8125rem;
  line-height: 1.4;
  white-space: normal;
}

.home-finance-card__terms-link {
  color: #00205b;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.home-finance-btn {
  border-radius: 10px !important;
  font-size: 0.9375rem !important;
  height: 44px !important;
  letter-spacing: 0 !important;
  min-height: 44px;
  text-transform: none !important;
  touch-action: manipulation;
  transition-duration: 150ms;
  transition-property: transform, background-color, color, box-shadow, opacity;
  transition-timing-function: ease-out;
}

.home-finance-btn:active:not(.v-btn--disabled) {
  transform: scale(0.96);
}

.home-finance-btn--primary {
  background: #00205b !important;
  box-shadow: 0 1px 2px rgba(0, 32, 91, 0.18), 0 6px 16px rgba(0, 32, 91, 0.12);
  color: #ffffff !important;
}

.home-finance-btn--primary:hover:not(.v-btn--disabled) {
  background: #001846 !important;
}

.home-finance-btn:focus-visible {
  outline: 2px solid #00205b;
  outline-offset: 3px;
}

@media (prefers-reduced-motion: reduce) {
  .home-page .home-enter {
    animation: none;
  }

  .home-page .home-action,
  .home-finance-btn {
    transition: none;
  }

  .home-page .home-action:active,
  .home-finance-btn:active:not(.v-btn--disabled) {
    transform: none;
  }
}
</style>
